<script setup lang="ts">
import { Question } from "@/types";
import AccordionList from "@/Components/Accordions/AccordionList.vue";
import { computed } from "vue";
import { useClient, Device } from "@/Composables/utils/useClient";

const props = defineProps<{
    items: Question[];
    faqBrand?: string;
    /** When true, adds stable data-testid for home vs home2 golden parity only. */
    showHomeParityMarkers?: boolean;
}>();

const { device } = useClient();
const isMobile = computed(() => device.value === Device.mobile);

const title = computed(() => {
    if (props.faqBrand) {
        return `FAQ Leasing ${props.faqBrand} Joinsteer`;
    }
    return "FAQ Leasing Premium Joinsteer";
});
</script>

<template>
    <div class="container faq landing-make faq--stacked">
        <h2
            class="landing-make__title"
            :data-testid="
                props.showHomeParityMarkers ? 'parity-home-faq-heading' : undefined
            "
        >
            {{ title }}
        </h2>

        <AccordionList
            :items="props.items"
            :is-show-more="false"
            icon-color-closed="#AAB2B2"
            :default-open="!isMobile"
            :first-accordion-test-id="
                props.showHomeParityMarkers ? 'parity-home-faq-first-item' : null
            "
            :first-accordion-question-test-id="
                props.showHomeParityMarkers
                    ? 'parity-home-faq-first-question'
                    : null
            "
        />
    </div>
</template>

<style lang="scss" scoped>
.faq--stacked {
    flex-direction: column;
    align-items: stretch;

    :deep(.accordions) {
        width: 100%;
    }

    .landing-make__title {
        margin-bottom: 2rem;
    }
}
</style>
